(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["highlights"] && !window.DesignMode) return;
  try {
      
  document.addEventListener('DOMContentLoaded', function () {  
      var slider;  
  
      function initializeSlider() {  
          if (window.innerWidth <= 800) {  
              if (!slider) {  
                  slider = tns({  
                      container: '.my-slider-highlights',  
                      items: 3,  
                      slideBy: 1,  
                      autoplay: false,  
                      controls: false, 
                      nav: true, 
                      navPosition: 'bottom',
                      mouseDrag: true,  
                      autoHeight: true,  
                      swipeAngle: false,  
                      center: true,  
                  });  
              }  
          } else {  
              if (slider) {  
                  slider.destroy();  
                  slider = null;  
              }  
          }  
      }  
  
      initializeSlider();  
  
      window.addEventListener('resize', function () {  
          initializeSlider();  
      });  
  });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-accordion"] && !window.DesignMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function () {
    const ingredients_accordion_init=async function(){
    const accordionItems=document.querySelectorAll(".accordion-item");
    const firstItem=document.querySelector(".accordion-item");
    console.log('firt Item accordion', firstItem)
    if(firstItem){
      firstItem.classList.toggle("active"); 
    }
    accordionItems.forEach((item=>{
      const header=item.querySelector(".accordion-header");
      header.addEventListener("click",(()=>{
        accordionItems.forEach((item=>{
          item.classList.remove("active")
        }));
        item.classList.toggle("active")
      }))
    }))
    };
  
    ingredients_accordion_init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-cross-sells-holiday"] && !window.DesignMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.cross-sell--slide');
  var container = document.querySelector('.cross-sell--sliderr');

  if (items.length > 1) {
    container.classList.add('my-slider-cross-sell');
    container.classList.remove('slider-cross-sell');
    var slider = tns({
      container: '.my-slider-cross-sell',
      items: 1,
      slideBy: 1,
      autoplay: false,
      lazyload: true,
      controls: false,
      navAsThumbnails: false,
      navPosition: 'bottom',
      edgePadding: 32,
      gutter: 16,
      mouseDrag: true,
      responsive: {
        640: {
          items: 1,
          edgePadding: 24,
          gutter: 24,
        },
        989: {
          items: 2,
          edgePadding: 24,
          gutter: 24,
        },
      }
    });
  } else {
    container.classList.add('slider-cross-sell');
    container.classList.remove('my-slider-cross-sell');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-cross-sells"]) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.cross-sell--slide');
  var container = document.querySelector('.cross-sell--sliderr');

  if (items.length > 1) {
    container.classList.add('my-slider-cross-sell');
    container.classList.remove('slider-cross-sell');
    var slider = tns({
      container: '.my-slider-cross-sell',
      items: 1,
      slideBy: 1,
      autoplay: false,
      lazyload: true,
      controls: false,
      navAsThumbnails: false,
      navPosition: 'bottom',
      edgePadding: 32,
      gutter: 16,
      mouseDrag: true,
      responsive: {
        640: {
          items: 1,
          edgePadding: 24,
          gutter: 24,
        },
        989: {
          items: 2,
          edgePadding: 24,
          gutter: 24,
        },
      }
    });
  } else {
    container.classList.add('slider-cross-sell');
    container.classList.remove('my-slider-cross-sell');
  }
});


  } catch(e) { console.error(e); }
})();
})();
